export const menuVehicles = [
	{
		id: "vehiclesIndex",
		text: "All vehicles",
		href: "/vehicles/",
		class: "tablet:hidden",
		image: {
			alt: "New Zealand from satellite view",
			mobile: { src: "/images/Locations_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/Locations_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
	{
		id: "small-cars",
		text: "Small cars",
		href: "/vehicles/small-cars/",
		class: "tablet:col-span-4",
		image: {
			alt: "Image of the Toyota Yaris Cross Hybrid",
			mobile: { src: "/images/small_cars_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/small_cars_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
	{
		id: "electric-vehicles",
		text: "Electric vehicles",
		href: "/vehicles/electric-vehicles/",
		class: "tablet:col-span-4",
		image: {
			alt: "Image of the Tesla Model 3",
			mobile: { src: "/images/electric_vehicles_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/electric_vehicles_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
	{
		id: "hybrid-cars",
		text: "Hybrid cars",
		href: "/vehicles/hybrid-cars/",
		class: "tablet:col-span-4",
		image: {
			alt: "Image of a Hyundai iMax People Carrier parked up at a New Zealand vineyard with rows of vines in the background",
			mobile: { src: "/images/hybrid_cars_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/hybrid_cars_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
	{
		id: "large-cars-suvs",
		text: "Large cars / SUVs",
		href: "/vehicles/large-cars-suvs/",
		class: "tablet:col-span-4",
		image: {
			alt: "Image of the Toyota Corolla Cross Hybrid",
			mobile: { src: "/images/large_cars_suvs_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/large_cars_suvs_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
	{
		id: "4-wheel-drives",
		text: "4 Wheel drives",
		href: "/vehicles/4-wheel-drives/",
		class: "tablet:col-span-4",
		image: {
			alt: "Image of the Toyota Rav4 AWD Hybrid",
			mobile: { src: "/images/4_wheel_drives_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/4_wheel_drives_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
	{
		id: "van-or-people-carriers",
		text: "Van or people carriers",
		href: "/vehicles/van-or-people-carriers/",
		class: "tablet:col-span-4",
		image: {
			alt: "Image of a Hyundai iMax People Carrier parked up at a New Zealand vineyard with rows of vines in the background",
			mobile: { src: "/images/van_or_people_carriers_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/van_or_people_carriers_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
	{
		id: "car-rental-accessories",
		text: "Car rental accessories",
		href: "/vehicles/car-rental-accessories/",
		class: "tablet:col-span-4",
		image: {
			alt: "Image of a snow chains on a car rental vehicle",
			mobile: { src: "/images/car_rental_accessories_menu_Mobile.jpg", width: 80, height: 40 },
			tablet: { src: "/images/car_rental_accessories_menu_Tablet.jpg", width: 296, height: 148 },
		},
	},
]
